import { useEffect, useState } from 'react';
import { db, auth } from '../FirebaseComp/firebase'; // Make sure this points to your correct Firebase config
import { toast } from 'react-toastify';
import { collection, addDoc, getDocs, serverTimestamp } from 'firebase/firestore';
import './visual-impaired-registration.css';
import { signOut } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';


function VisualImpairedRegistration() {
//   const [isSubmitting, setIsSubmitting] = useState(false);
//  // Form state of add member
//   const [formData, setFormData] = useState({
//     registrationNo: '',
//     fullName: '',
//     nicNo: '',
//     phoneNo: '',
//     address: '',
//     province: '',
//     district: '',
//     city: '',
//     certifiedBy: '',
//     certifiedDate: '',
//     certifierName: ''
//   });

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setFormData(prevState => ({
//       ...prevState,
//       [name]: value
//     }));
//   };

// const handleSubmit = async (e) => {
//   e.preventDefault();
//   setIsSubmitting(true);
  
//   try {
//     // Add document to Firestore 'members' collection
//     await addDoc(collection(db, 'members'), {
//       ...formData,
//       createdAt: serverTimestamp(),
//       status: 'active'
//     });
    
//     // Show toast + alert
//     toast.success('Member registered successfully!');
//     alert('Registration is successful!');
    
//     // Reset form
//     setFormData({
//       registrationNo: '',
//       fullName: '',
//       nicNo: '',
//       phoneNo: '',
//       address: '',
//       province: '',
//       district: '',
//       city: '',
//       certifiedBy: '',
//       certifiedDate: '',
//       certifierName: ''
//     });
//   } catch (error) {
//     console.error('Error adding document: ', error);
//     toast.error('Failed to register member. Please try again.');
//   } finally {
//     setIsSubmitting(false);
//   }
// };
  const [activeTab, setActiveTab] = useState('addMember');
  const [isLoggingOut, setIsLoggingOut] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    registrationNo: '',
    fullName: '',
    nicNo: '',
    phoneNo: '',
    address: '',
    province: '',
    district: '',
    city: '',
    certifiedBy: '',
    certifiedDate: '',
    certifierName: ''
  });

  // ✅ Generate the next registration number
  const generateRegistrationNumber = async () => {
    const snapshot = await getDocs(collection(db, 'members'));
    const totalCount = snapshot.size + 1; // next number
    const formattedNumber = totalCount.toString().padStart(3, '0'); // e.g. 001
    const regNo = `VI-${formattedNumber}`;
    setFormData(prev => ({ ...prev, registrationNo: regNo }));
  };

  useEffect(() => {
    generateRegistrationNumber();
  }, []);

  const handleLogout = async () => {
    setIsLoggingOut(true);
    try {
      await signOut(auth);
      toast.success('Logged out successfully!');
      navigate('/', { replace: true });
    } catch (error) {
      console.error('Logout error:', error);
      toast.error('Logout failed. Please try again.');
    } finally {
      setIsLoggingOut(false);
    }
  };

  const handleTabClick = (tab) => {
    if (tab === 'logout') {
      handleLogout();
      return;
    }
    setActiveTab(tab);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      await addDoc(collection(db, 'members'), {
        ...formData,
        createdAt: serverTimestamp(),
        status: 'active'
      });

      toast.success('Member registered successfully!');
      
      // Generate new registration number after successful registration
      generateRegistrationNumber();

      // Reset form except registration number
      setFormData(prev => ({
        ...prev,
        fullName: '',
        nicNo: '',
        phoneNo: '',
        address: '',
        province: '',
        district: '',
        city: '',
        certifiedBy: '',
        certifiedDate: '',
        certifierName: ''
      }));

    } catch (error) {
      console.error('Error adding document: ', error);
      toast.error('Failed to register member. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };



  



  return (
<div className="visual-impaired-registration">
  {/* Banner */}
  <div className="banner-visual">
    <img
      src="/visual-impaired-banner.png"
      alt="Visual Impaired Registration Banner"
      className="banner-image-visual"
    />
    <div className="banner-overlay-visual">
      <h1>Visual Impaired Individuals Registration</h1>
    </div>
  </div>

      <div className="form-container-visual">
        {/* <h3 className="form-title-visual">Member Registration</h3> */}

        <form onSubmit={handleSubmit} className="member-form-visual">

          {/* Personal Information */}
          <fieldset>
            <legend>Personal Information</legend>
            <div className="form-group-visual">
              <div className="form-group">
                <label htmlFor="registrationNo">Registration No:</label>
                <input
                  type="text"
                  id="registrationNo"
                  name="registrationNo"
                  value={formData.registrationNo}
                  readOnly      // 👈 prevent editing
                  required
                />
              </div>

              <div className="form-group-visual">
                <label htmlFor="fullName">Full Name</label>
                <input
                  type="text"
                  id="fullName"
                  name="fullName"
                  value={formData.fullName}
                  onChange={handleInputChange}
                  required
                />
              </div>
            </div>

            <div className="form-row-visual">
              <div className="form-group-visual">
                <label htmlFor="nicNo">NIC No</label>
                <input
                  type="text"
                  id="nicNo"
                  name="nicNo"
                  value={formData.nicNo}
                  onChange={handleInputChange}
                  required
                />
              </div>

              <div className="form-group-visual">
                <label htmlFor="phoneNo">Phone No</label>
                <input
                  type="tel"
                  id="phoneNo"
                  name="phoneNo"
                  value={formData.phoneNo}
                  onChange={handleInputChange}
                  required
                />
              </div>
            </div>

            <div className="form-group-visual full-width">
              <label htmlFor="address">Address</label>
              <textarea
                id="address"
                name="address"
                value={formData.address}
                onChange={handleInputChange}
                rows="3"
                required
              />
            </div>
          </fieldset>

          {/* Location Information */}
          <fieldset>
            <legend>Location Information</legend>
            <div className="form-row-visual">
              <div className="form-group-visual">
                <label htmlFor="province">Province</label>
                <select
                  id="province"
                  name="province"
                  value={formData.province}
                  onChange={handleInputChange}
                  required
                >
                  <option value="">Select Province</option>
                  <option value="Western">Western</option>
                  <option value="Central">Central</option>
                  <option value="Southern">Southern</option>
                  <option value="Northern">Northern</option>
                  <option value="Eastern">Eastern</option>
                  <option value="North Western">North Western</option>
                  <option value="North Central">North Central</option>
                  <option value="Uva">Uva</option>
                  <option value="Sabaragamuwa">Sabaragamuwa</option>
                </select>
              </div>

              <div className="form-group-visual">
                <label htmlFor="district">District</label>
                <input
                  type="text"
                  id="district"
                  name="district"
                  value={formData.district}
                  onChange={handleInputChange}
                  required
                />
              </div>
            </div>

            <div className="form-group-visual full-width">
              <label htmlFor="city">City</label>
              <input
                type="text"
                id="city"
                name="city"
                value={formData.city}
                onChange={handleInputChange}
                required
              />
            </div>
          </fieldset>

          {/* Certification */}
          <fieldset>
            <legend>Certification</legend>
            <div className="form-group-visual full-width">
              <label>Certified By</label>
              <div className="radio-group-visual">
                <label className="radio-option-visual">
                  <input
                    type="radio"
                    name="certifiedBy"
                    value="Ophthalmologist"
                    checked={formData.certifiedBy === 'Ophthalmologist'}
                    onChange={handleInputChange}
                    required
                  />
                  <span>Ophthalmologist</span>
                </label>

                <label className="radio-option-visual">
                  <input
                    type="radio"
                    name="certifiedBy"
                    value="Optometrist"
                    checked={formData.certifiedBy === 'Optometrist'}
                    onChange={handleInputChange}
                  />
                  <span>Optometrist</span>
                </label>
              </div>
            </div>

            <div className="form-row-visual">
              <div className="form-group-visual">
                <label htmlFor="certifiedDate">Certified Date</label>
                <input
                  type="date"
                  id="certifiedDate"
                  name="certifiedDate"
                  value={formData.certifiedDate}
                  onChange={handleInputChange}
                  required
                />
              </div>

              <div className="form-group-visual">
                <label htmlFor="certifierName">Certifier Name</label>
                <input
                  type="text"
                  id="certifierName"
                  name="certifierName"
                  value={formData.certifierName}
                  onChange={handleInputChange}
                  required
                />
              </div>
            </div>
          </fieldset>

          {/* Actions */}
          <div className="form-actions-visual">
            <button
              type="submit"
              className="submit-button-visual"
              disabled={isSubmitting}
            >
              {isSubmitting ? 'Registering...' : 'Register Member'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default VisualImpairedRegistration;
